import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ContactsService } from 'libs/data/contacts/src/lib/services/contacts.service';
import { map, tap } from 'rxjs';

@Component({
  selector: 'epc-business-contacts',
  templateUrl: './business-contacts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BusinessContactsComponent {
  @Output() public readonly showAll = new EventEmitter();
  protected showShowAllButton = false;
  private readonly numberOfContactsToDisplay = 3;

  public readonly isLoading$ = this.contactsService.isLoading$;
  public readonly contacts$ = this.contactsService.contacts$.pipe(
    tap((contacts) => {
      this.showShowAllButton =
        contacts !== null && contacts.length > this.numberOfContactsToDisplay;
    }),
    map((contacts) =>
      [...(contacts ?? [])]
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .slice(0, this.numberOfContactsToDisplay),
    ),
  );

  constructor(private readonly contactsService: ContactsService) {}

  protected showAllClicked(): void {
    this.showAll.emit();
  }
}
